import React, { useEffect, useState } from 'react';
interface FloatingCheckoutCTAProps {
  href: string;
  onClick?: () => void;
}
export const FloatingCheckoutCTA = ({
  href,
  onClick
}: FloatingCheckoutCTAProps) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after the user has scrolled past most of the hero (~600px)
      setVisible(window.scrollY > 600);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed z-40 transition-all duration-500 ease-out
        bottom-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-md
        sm:left-auto sm:right-6 sm:bottom-6 sm:translate-x-0 sm:w-auto sm:max-w-none
        ${visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-6 pointer-events-none'}`} data-id="element-13">
      <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} tabIndex={visible ? 0 : -1} aria-hidden={!visible} className="flex items-center justify-center gap-2 bg-gold text-foreground font-display font-extrabold rounded-full px-6 py-4 text-base sm:text-base shadow-gold ring-2 ring-gold/30 hover:scale-[1.03] hover:brightness-105 transition-all duration-300 animate-pulse-soft" data-id="element-14">
        <span data-id="element-15">Quiero la colección</span>
      </a>
    </div>;
};